module.exports = __webpack_public_path__ + "img/ServiciosenLinea.eab9325a.png";